import React, { useEffect, useState } from "react";
import { useRange } from "react-instantsearch";
import FilterSection from "../../../components/pages/SearchPage/components/FilterSection";
import { Slider as MuiSlider } from "@material-ui/core";
import styled from "styled-components";
import FlexBox from "../../../components/elements/v2/Box/FlexBox";
import { useSearchPageContext } from "../../../components/pages/SearchPage/SearchPageContext";

export default function PriceFilter() {
  const { myCurrency } = useSearchPageContext();
  const { start, range, canRefine, refine } = useRange({ attribute: "price_aud" });
  const { min, max } = range;
  const [value, setValue] = useState([min, max]);

  const hasSelectedItems = Number.isFinite(start[0]) || Number.isFinite(start[1]);
  const from = Math.max(min, Number.isFinite(start[0]) ? start[0] : min);
  const to = Math.min(max, Number.isFinite(start[1]) ? start[1] : max);

  useEffect(() => {
    setValue([from, to]);
  }, [from, to]);

  if (!canRefine) return null;

  const handleChange = (event: React.ChangeEvent<{}>, newValue: number | number[]) => {
    if (typeof newValue === "number") setValue([0, newValue]);
    else setValue(newValue as [number, number]);
  };

  const handleCommit = (event: React.ChangeEvent<{}>, newValue: number | number[]) => {
    if (typeof newValue === "number") refine([0, newValue]);
    else refine(newValue as [number, number]);
  };

  return (
    <FilterSection label="Price" canRefine={canRefine} hasSelectedItems={hasSelectedItems}>
      <div className="t-searchFilterGroup">
        <Values>
          <div>
            {myCurrency.symbol}
            {value[0]}
          </div>
          <div> – </div>
          <div>
            {myCurrency.symbol}
            {value[1]}
          </div>
        </Values>
        <Slider
          value={value}
          onChange={handleChange}
          onChangeCommitted={handleCommit}
          min={min}
          max={max}
        />
      </div>
    </FilterSection>
  );
}

const Values = styled(FlexBox)`
  gap: 0.5rem;
  margin-bottom: 0.5rem;
  font-size: 1rem;
  font-weight: 600;
  color: #555;
`;

const Slider = styled(MuiSlider)`
  &.MuiSlider-root {
    color: #ff9579;
  }
`;
